'use strict';

/**
 * @ngdoc function
 * @name formDesignerApp.controller:fdPreviewCtrl
 * @description
 * # fdPreviewCtrl
 * Controller of the preview
 */

angular.module('formApp').controller('fdPreviewCtrl', [
  '$scope',
  'CONFIG',
  function ($scope, CONFIG) {
    $scope.init = function () {
      $scope.models.previewModeDebug = false;
      $scope.models.iframeUrl = CONFIG.PREVIEW_URL;
    };

    $scope.hidePreview = function () {
      $scope.$emit('preview-close');
    };

    $scope.selectText = function (containerId, win) {
      var el = document.getElementById(containerId);
      win = win || window;
      var doc = win.document,
        sel,
        range;
      if (win.getSelection && doc.createRange) {
        sel = win.getSelection();
        range = doc.createRange();
        range.selectNodeContents(el);
        sel.removeAllRanges();
        sel.addRange(range);
      } else if (doc.body.createTextRange) {
        range = doc.body.createTextRange();
        range.moveToElementText(el);
        range.select();
      }

      return false;
    };

    $scope.init();
  }
]);
